<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :persistent="editar"
    scrollable
  >
    <v-card>
      <v-card-title>
        {{ nueva ? 'Nueva' : editar ? 'Editar' : 'Ver' }} acción
        <v-spacer></v-spacer>
        <template v-if="!nueva">
          <v-switch
            v-model="editar"
            label="Editar"
            class="mt-0"
            hide-details
            dense
          ></v-switch>
          <v-divider class="mx-3" vertical></v-divider>
        </template>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-8">
        <v-form ref="form">
          <v-row class="pb-2">
            <v-col cols="5" sm="3" class="py-0">
              <v-text-field
                v-model.trim="accion.articulo_codigo"
                label="Art. Código"
                type="number"
                :readonly="!nueva"
                :filled="!nueva"
                :rules="[rules.required]"
                validate-on-blur
                outlined
                dense
                @change="buscarArticulo()"
              ></v-text-field>
            </v-col>
            <v-col cols="7" class="py-0">
              <v-text-field
                v-model="nombre"
                label="Artículo nombre"
                outlined
                readonly
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="5" sm="2" class="py-0">
              <v-text-field
                v-model.trim="accion.cupo"
                label="Cupo"
                type="number"
                :readonly="!editar"
                :filled="!editar"
                :rules="[rules.required]"
                validate-on-blur
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-row>
                <v-col>
                  <FechaPicker
                    v-model="accion.fecha_desde"
                    label="Fecha desde"
                    :disabled="!editar"
                  />
                </v-col>
                <v-col>
                  <FechaPicker
                    v-model="accion.fecha_hasta"
                    label="Fecha hasta"
                    :disabled="!editar"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                v-model.trim="accion.nombre"
                label="Nombre acción"
                :readonly="!editar"
                :filled="!editar"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card outlined flat>
            <v-data-table
              :items="detalle.filter(dt => dt.accion != 'DELETE')"
              :headers="headers"
              :items-per-page="-1"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <div class="d-flex pt-2 px-2">
                  <span class="body-1">
                    Beneficios
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="success"
                    :disabled="!editar || disponibles.length == 0"
                    small
                    @click="detalle.push({ id: null, bono: null, estricto: null, accion: 'INSERT' })"
                  >
                    Agregar
                    <v-icon small right>fas fa-plus</v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.beneficio`]="{ item }">
                <v-autocomplete
                  v-model="item.id"
                  :items="disponibles.filter(dp => !detalle.filter(dt => dt.accion != 'DELETE').map(det => det.id).includes(dp.id) || dp.id == item.id)"
                  item-text="descripcion"
                  item-value="id"
                  :prepend-icon="`fas fa-${disponibles.find(dp => dp.id == item.id) ? disponibles.find(dp => dp.id == item.id).tipo == 'PROMOCION' ? 'percentage' : 'credit-card' : ''}`"
                  :readonly="!editar || item.accion != 'INSERT'"
                  :filled="!editar || item.accion != 'INSERT'"
                  :rules="[rules.required]"
                  validate-on-blur
                  hide-details
                  dense
                  @change="agregar(item)"
                >
                  <template v-slot:item="{ item }">
                    <div class="v-list-item v-list-item__title ml-n4 mr-n4">
                      <v-icon
                        :color="disponibles.find(dp => dp.id == item.id) ? disponibles.find(dp => dp.id == item.id).tipo == 'PROMOCION' ? 'green' : 'purple' : ''"
                        small
                        left
                      >
                        fas fa-{{ disponibles.find(dp => dp.id == item.id) ? disponibles.find(dp => dp.id == item.id).tipo == 'PROMOCION' ? 'percentage' : 'credit-card' : '' }}
                      </v-icon>
                      {{ item.descripcion }}
                    </div>
                  </template>
                </v-autocomplete>
              </template>
              <template v-slot:[`item.bono`]="{ item }">
                <v-text-field
                  v-model="item.bono"
                  type="number"
                  prefix="$"
                  :readonly="!editar"
                  :filled="!editar"
                  :rules="[rules.required]"
                  validate-on-blur
                  hide-details
                  dense
                  @change="modifica(item)"
                ></v-text-field>
              </template>
              <template v-slot:[`item.estricto`]="{ item }">
                <v-checkbox
                  v-model="item.estricto"
                  :true-value="1"
                  :false-value="null"
                  :disabled="!editar"
                  hide-details
                  dense
                  @change="modifica(item)"
                ></v-checkbox>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  color="error"
                  :title="nueva ? 'Quitar' : 'Desvincular'"
                  :disabled="!editar"
                  small
                  @click="desvincular(item)"
                >
                  fas fa-{{ nueva ? 'times-circle' : 'trash' }}
                </v-icon>
                <v-icon
                  color="info"
                  class="ml-2"
                  :title="`Ver ${item.tipo}`"
                  small
                  @click="ver(item)"
                >
                  fas fa-eye
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-alert
                  class="mx-auto mt-4"
                  max-width="400"
                  type="warning"
                  border="left"
                  dense
                  text
                >
                  No hay beneficios disponibles
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end py-4">
        <v-btn
          class="mr-2"
          :color="editar ? 'error' : 'secondary'"
          @click="dialog = false"
        >
          {{ editar ? 'Cancelar' : 'Volver' }}
        </v-btn>
        <BtnConfirmar
          v-if="editar"
          @action="guardar()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnConfirmar from '@/components/util/BtnConfirmar.vue'
import FechaPicker from '@/components/util/FechaPicker.vue'
import { order_list_by } from '../../util/utils'

export default {
  data () {
    return {
      nueva: false,
      editar: false,
      nombre: '',
      accion: {},
      detalle: [],
      detalle_copy: [],
      disponibles: [],
      headers: [
        { text: 'Nombre', value: 'beneficio', sortable: false, filterable: false },
        { text: 'Monto Bono S/IVA', value: 'bono', sortable: false, filterable: false, width: 120 },
        { text: 'Estricto', value: 'estricto', sortable: false, filterable: false, width: 1, align: 'center' },
        { text: 'Acciones', value: 'actions', sortable: false, filterable: false, width: 1 }
      ],
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },
  props: {
    value: Boolean,
    p_accion: Object
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    BtnConfirmar,
    FechaPicker
  },
  watch: {
    async dialog (val) {
      if (val) {
        if (this.p_accion == null) {
          this.nueva = true
          this.editar = true
          this.nombre = ''
          this.accion = {
            fecha_desde: null,
            fecha_hasta: null
          }
        } else {
          this.nueva = false
          this.editar = false
          this.nombre = JSON.parse(JSON.stringify(this.p_accion.articulo_nombre))
          this.accion = JSON.parse(JSON.stringify(this.p_accion))
          await new Promise(resolve => setTimeout(resolve, 1))
          this.getDetalle()
        }
      } else {
        this.$refs.form.resetValidation()
        this.disponibles = []
        this.detalle = []
      }
    },
    editar (val) {
      if (!val && !this.nueva) {
        this.accion = JSON.parse(JSON.stringify(this.p_accion))
        this.detalle = JSON.parse(JSON.stringify(this.detalle_copy))
      }
    }
  },
  methods: {
    async guardar () {
      if (!this.$refs.form.validate()) return

      if (!this.accion.fecha_desde || !this.accion.fecha_hasta) {
        this.$store.dispatch('show_snackbar', {
          text: 'Debe seleccionar una fecha desde y hasta',
          color: 'orange'
        })
        return
      }

      if (this.nueva && this.detalle.filter(dt => dt.accion != 'DELETE').length == 0) {
        this.$store.dispatch('show_snackbar', {
          text: 'Debe agregar al menos un beneficio',
          color: 'orange'
        })
        return
      }

      this.$store.state.loading = true
      let result = await this.$store.dispatch(`accionMarca/${this.nueva ? 'nueva' : 'editar'}Accion`, {
        ...this.accion,
        detalle: this.detalle,
        articulo_nombre: this.nombre
      })
      this.$store.state.loading = false

      if (!result.exito) {
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'error'
        })
        return
      }

      if (this.nueva) {
        this.$swal.fire({
          title: result.message,
          icon: 'success'
        })
      } else {
        this.$emit('editar', JSON.parse(JSON.stringify(this.accion)))
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'success'
        })
      }
      this.dialog = false
    },
    async getDetalle () {
      await this.getAcciones()

      this.$store.state.loading = true
      let result = await this.$store.dispatch('accionMarca/getAccionesDetalle', this.accion.id)
      this.$store.state.loading = false

      if (!result.exito) {
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'orange'
        })
        return
      }

      this.detalle = result.data
      this.detalle_copy = JSON.parse(JSON.stringify(this.detalle))

      for (const detalle of this.detalle) {
        let existe = this.disponibles.find(dp => dp.id == detalle.id)
        if (!existe) {
          this.disponibles.push({
            id: detalle.id,
            descripcion: detalle.descripcion,
            tipo: detalle.tipo
          })
        }
      }
      order_list_by(this.disponibles, 'descripcion')
    },
    async buscarArticulo () {
      this.disponibles = []
      this.detalle = []
      this.nombre = ''

      if (!this.accion.articulo_codigo) {
        return this.$store.dispatch('show_snackbar', {
          text: 'Ingrese un código de artículo',
          color: 'orange'
        })
      }

      this.$store.state.loading = true
      await this.$store.dispatch('articulos/get_articulo_activo', this.accion.articulo_codigo)
        .then((res) => {
          this.nombre = res.data.nombre
        }).catch((error) => {
          this.accion.articulo_codigo = null
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'orange'
          })
        })
      this.$store.state.loading = false

      this.getAcciones()
    },
    async getAcciones () {
      if (!this.accion.articulo_codigo) return

      this.$store.state.loading = true
      let result = await this.$store.dispatch('accionMarca/getPromosFin', this.accion.articulo_codigo)
      this.$store.state.loading = false

      if (!result.exito) {
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'orange'
        })
        return
      }

      this.disponibles = result.data

      order_list_by(this.disponibles, 'descripcion')
    },
    agregar (item) {
      if (item.accion == 'INSERT') {
        let disp = this.disponibles.find(dp => dp.id == item.id)
        item.tipo = disp.tipo
      }
      let existe = this.detalle.find(dt => dt.id == item.id)
      if (existe && existe.accion == 'DELETE') {
        let original = this.detalle_copy.find(dc => dc.id == existe.id)
        item.accion = original.accion
        item.bono = original.bono
        item.estricto = original.estricto

        let index = this.detalle.indexOf(existe)
        this.detalle.splice(index, 1)
      }
    },
    modifica (item) {
      if (item.accion != 'INSERT') {
        item.accion = 'UPDATE'
      }
    },
    desvincular (item) {
      if (item.accion == 'INSERT') {
        let index = this.detalle.indexOf(item)
        this.detalle.splice(index, 1)
      } else {
        item.accion = 'DELETE'
      }
    },
    ver (item) {
      const path = item.tipo == 'PROMOCION' ? '/ver-promo/' : '/financiacion/'
      const routeData = this.$router.resolve({ path: path + item.codigo })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>